// import xssOri from 'xss';
import { forwardRef, Fragment } from "react";
import classnames from "classnames";

// const options = {
//   stripIgnoreTag: true,
//   whiteList: {
//     ol: ['start'],
//     p: [],
//   },
// }
// const xss = new xssOri.FilterXSS(options);

const DangerousMessage = forwardRef(({ html, htmlTag, className, ...props }, ref) => {
  // Handle Fragment case - Fragment cannot use dangerouslySetInnerHTML
  // So we use a div with display: contents to avoid wrapper element
  if (htmlTag === "Fragment" || htmlTag === Fragment) {
    return (
      <div
        ref={ref}
        {...props}
        className={classnames("dangerous-message", className)}
        style={{ display: "contents", ...props.style }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }

  const HtmlTag = `${htmlTag}`;
  return (
    <HtmlTag
      ref={ref}
      {...props}
      className={classnames("dangerous-message", className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
    // dangerouslySetInnerHTML={{ __html: xss.process(html) }} />
  );
});

DangerousMessage.Div = forwardRef((props, ref) => <DangerousMessage ref={ref} htmlTag="div" {...props} />);
DangerousMessage.Span = forwardRef((props, ref) => <DangerousMessage ref={ref} htmlTag="span" {...props} />);
DangerousMessage.Fragment = forwardRef((props, ref) => <DangerousMessage ref={ref} htmlTag="Fragment" {...props} />);

export default DangerousMessage;
